/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import { usePageNavigation } from 'bundles/unified-description-page-common/contexts/PageNavigationContext';

type Props = {
  pageCta?: React.ReactNode;
};

const animateIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(200px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const styles = {
  container: () => css`
    position: fixed;

    /* 1000 z-index is used on flyout menu on mobile. This shouldn't cover that. */
    z-index: 999;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(200px);
    background: var(--cds-color-neutral-background-primary);
    padding: var(--cds-spacing-200);
    box-shadow: 0 0 4px rgb(0 0 0 / 15%);
    display: none;
    ${breakpoints.down('sm')} {
      display: block;
    }
  `,
  slideIn: css`
    display: block;
    animation: 0.5s ease-in-out 1 normal forwards running ${animateIn};
  `,
};

const MobileCtaModule = ({ pageCta }: Props) => {
  const { showFixedMobileCta } = usePageNavigation();

  if (!pageCta) {
    return null;
  }

  return (
    <div data-e2e="mobile-cta-module" css={[styles.container, showFixedMobileCta ? styles.slideIn : undefined]}>
      {pageCta}
    </div>
  );
};

export default MobileCtaModule;
